import {createStore} from 'vuex'

import buildings from "./buildings";
import modals from "./modals";

export default createStore({
    state: {
        baseUrl: "https://api.debintercom.xdev.team" //"http://5.188.118.91:5100"
    },
    mutations: {},
    actions: {
        baseRequest(ctx, {url, headers, method, data}) {
            return new Promise((resolve) => {
                let sendData = (data) ? JSON.stringify(data) : null
                let xhr = new XMLHttpRequest()
                xhr.open(method, url, true)
                Object.keys(headers).forEach(name => {
                    xhr.setRequestHeader(name, headers[name])
                })
                xhr.send(sendData)
                xhr.onreadystatechange = function () {
                    if (xhr.readyState != 4) return;

                    let response
                    try {
                        response = JSON.parse(xhr.responseText)
                    } catch {
                        response = xhr.responseText
                    }

                    resolve({status: xhr.status, response})
                }
            })
        },
        request(ctx, {path, method, sendData}) {
            return new Promise((resolve) => {
                let url = ctx.state.baseUrl + path
                let headers = {
                    "Authorization": 'Bearer ' + localStorage.getItem('token'),
                    "Content-Type": "application/json"
                }

                ctx.dispatch("baseRequest", {url, headers, method, data: sendData})
                    .then(r => {
                        if (r.status > 299 || r.status < 200) {
                            ctx.commit("setErrorMessage", r.response)
                            if (r.response) {
                                if (r.response.message) {
                                    ctx.commit("setErrorMessage", r.response.message)
                                }
                            }
                            ctx.commit("closeAllModals")
                            ctx.commit("setShowModal", {name: "Error", val: true})
                        }
                        resolve(r)
                    })
            })
        }
    },
    modules: {
        buildings,
        modals
    }
})
